import{useContext as t}from"react";import e from"../ThemeContext/ThemeContext.js";const useMotif=o=>{const m=t(e);return o?{...m,motif:o}:m};useMotif.displayName="useMotif";export{useMotif as default};
//# sourceMappingURL=useMotif.js.map
